import React, { useState } from "react";

function EmploymentCheck(props) {
const title = props.title


  return (
    <div class="form-check mt-2">
      <input
        className="form-check-input appearance-none h-3 w-3 border border-gray-300 rounded-sm bg-white dark:bg-gray-700 checked:bg-cyan-600 checked:border-cyan-600 focus:outline-none transition duration-200 mt-2 align-top bg-no-repeat bg-center bg-contain float-left mr-1 cursor-pointer"
        type="checkbox"
        value=""
        id="flexCheckChecked"
      />
      <label
        className="form-check-label inline-block text-gray-300 text-xs"
        for="flexCheckChecked"
      >
        {title}
      </label>
    </div>
  );
}

export default EmploymentCheck;
